function uniqueStrings(values) {
    return [...new Set(values.filter((value) => Boolean(value?.trim())))];
}
export function getRootFolderEntityTypeKeys(structure, rootFolderKey) {
    if (!structure) {
        return [];
    }
    const entityTypeKeys = new Set();
    for (const node of structure.folderNodes ?? []) {
        if (node.kind !== "collection")
            continue;
        if (node.rootFolderKey !== rootFolderKey)
            continue;
        if (!node.entityTypeKey)
            continue;
        entityTypeKeys.add(node.entityTypeKey);
    }
    return Array.from(entityTypeKeys);
}
export function resolveCompiledRootFolder(structure, rootFolderKeyOrSlug) {
    return ((structure?.rootFolders ?? []).find((rootFolder) => {
        const candidateSlug = rootFolder.slug || rootFolder.key;
        return candidateSlug === rootFolderKeyOrSlug || rootFolder.key === rootFolderKeyOrSlug;
    }) ?? null);
}
export function resolveCompiledRootFolderNode(input) {
    const rootFolder = resolveCompiledRootFolder(input.structure, input.rootFolderKeyOrSlug);
    if (!rootFolder) {
        return null;
    }
    return ((input.structure?.folderNodes ?? []).find((node) => node.kind === "root" && node.rootFolderKey === rootFolder.key) ?? null);
}
export function requireCompiledProjectTreeFolderKind(input) {
    const projectTreeFolderKind = input.rootNode.settings?.projectTreeFolders?.kind;
    if (!projectTreeFolderKind) {
        throw new Error(`Root folder '${input.rootFolder.key}' is missing projectTreeFolders configuration.`);
    }
    return projectTreeFolderKind;
}
export function rootFolderSupportsProjectTreeFolders(input) {
    return Boolean(resolveCompiledRootFolderNode(input)?.settings?.projectTreeFolders?.enabled === true);
}
export function getCompiledRootFolderLabel(structure, rootFolderKeyOrSlug) {
    return resolveCompiledRootFolder(structure, rootFolderKeyOrSlug)?.label ?? null;
}
export function listCompiledRootFolderSearchAliases(rootFolder) {
    return uniqueStrings([rootFolder.key, rootFolder.slug, rootFolder.label]);
}
export function listFrameworkRootFolderPresentations(structure) {
    if (!structure) {
        return [];
    }
    const entityDisplays = new Map((structure.entityDisplays ?? []).map((display) => [display.entityTypeKey, display]));
    const rootFolders = [...(structure.rootFolders ?? [])].sort((left, right) => left.listOrder - right.listOrder);
    return rootFolders.map((rootFolder) => ({
        key: rootFolder.key,
        slug: rootFolder.slug,
        label: rootFolder.label,
        iconKey: rootFolder.iconKey,
        searchAliases: listCompiledRootFolderSearchAliases(rootFolder),
        collectionLabels: getRootFolderEntityTypeKeys(structure, rootFolder.key).map((entityTypeKey) => entityDisplays.get(entityTypeKey)?.pluralLabel ?? entityTypeKey),
    }));
}
